module.exports = __webpack_public_path__ + "static/img/aqzs16.441b16d3.jpg";